const TRACKING_QUERY_KEYS = ['dateStart', 'dateEnd', 'range', 'domains']

export function normalizeTrackingDomainUuids (value) {
  if (Array.isArray(value)) {
    return value
      .flatMap(item => normalizeTrackingDomainUuids(item))
      .filter(Boolean)
  }

  if (value && typeof value === 'object') {
    return normalizeTrackingDomainUuids(value.uuid || value.value)
  }

  if (typeof value === 'string') {
    return value
      .split(',')
      .map(item => item.trim())
      .filter(Boolean)
  }

  return []
}

function normalizeQueryForCompare (query) {
  return Object.keys(query || {})
    .sort()
    .reduce((result, key) => {
      const value = query[key]
      result[key] = Array.isArray(value) ? [...value].sort() : value
      return result
    }, {})
}

function sameQuery (left, right) {
  return JSON.stringify(normalizeQueryForCompare(left)) === JSON.stringify(normalizeQueryForCompare(right))
}

export function getTrackingQueryState (query, defaults = {}) {
  const selectedDomainUuids = normalizeTrackingDomainUuids(query?.domains)
  const hasDates = typeof query?.dateStart === 'string' && typeof query?.dateEnd === 'string'

  return {
    activeQuickRangeId: typeof query?.range === 'string' && query.range !== ''
      ? query.range
      : (hasDates ? null : defaults.activeQuickRangeId),
    dateRange: hasDates
      ? [query.dateStart, query.dateEnd]
      : defaults.dateRange,
    selectedDomainUuids: selectedDomainUuids.length > 0
      ? selectedDomainUuids
      : (defaults.selectedDomainUuids || [])
  }
}

export function buildTrackingQueryFromState ({ activeQuickRangeId, dateRange, selectedDomainUuids }) {
  const query = {}

  if (activeQuickRangeId) {
    query.range = activeQuickRangeId
  }

  if (Array.isArray(dateRange) && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
    query.dateStart = dateRange[0]
    query.dateEnd = dateRange[1]
  }

  const normalizedDomainUuids = normalizeTrackingDomainUuids(selectedDomainUuids)
  if (normalizedDomainUuids.length > 0) {
    query.domains = normalizedDomainUuids
  }

  return query
}

export function trackingQueryFromRoute (route) {
  const currentQuery = route?.query || {}
  return TRACKING_QUERY_KEYS.reduce((query, key) => {
    if (currentQuery[key] !== undefined) {
      query[key] = currentQuery[key]
    }
    return query
  }, {})
}

export function syncTrackingQueryFromVm (vm) {
  if (!vm || !vm.$route || !vm.$router) {
    return
  }

  const currentQuery = { ...(vm.$route.query || {}) }
  TRACKING_QUERY_KEYS.forEach(key => {
    delete currentQuery[key]
  })

  const nextQuery = {
    ...currentQuery,
    ...buildTrackingQueryFromState({
      activeQuickRangeId: vm.activeQuickRangeId,
      dateRange: vm.dateRange,
      selectedDomainUuids: vm.selectedDomainUuids
    })
  }

  if (sameQuery(vm.$route.query || {}, nextQuery)) {
    return
  }

  vm.$router.replace({ path: vm.$route.path, query: nextQuery }).catch(() => {})
}

export function formatTrackingDomainSelectionLabel (selectedDomainUuids, domainOptions) {
  const selectedUuids = normalizeTrackingDomainUuids(selectedDomainUuids)
  const count = selectedUuids.length

  if (count > 1) {
    return `${count} domaines`
  }

  if (count === 1) {
    const selectedUuid = selectedUuids[0]
    const domain = (Array.isArray(domainOptions) ? domainOptions : [])
      .find(option => option?.uuid === selectedUuid)

    return domain?.label || '1 domaine'
  }

  return 'Tous les domaines'
}
